import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const SmartHome: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <circle cx='390.9' cy='540' r='30' />
    <path d='m475.75 497.57c-46.79-46.79-122.92-46.79-169.71 0l-21.21-21.21c58.48-58.49 153.65-58.49 212.13 0z' />
    <path d='m539.39 433.93c-81.88-81.88-215.11-81.88-296.99 0l-21.21-21.21c45.33-45.33 105.6-70.29 169.71-70.29s124.38 24.96 169.71 70.29l-21.21 21.21z' />
    <path d='m660 660h-540.43v-357.67l239.29-172.78c18.71-12.8 42.88-12.8 61.59-.02l.31.22 239.24 172.57zm-510.43-30h480.43v-312.32l-226.62-163.47c-8.36-5.63-19.09-5.63-27.45 0l-226.36 163.46z' />
  </IconBase>
));

SmartHome.displayName = 'SmartHome';

export default SmartHome;
